'use client'

import { ElectronicsDisclaimerSectionModel } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

type Props = { content: ElectronicsDisclaimerSectionModel }

const DisclaimerSection = ({ content: { text } }: Props) => {
  return (
    <section data-testid="disclaimer-section" className="electronics__disclaimer-section">
      <p className="electronics__disclaimer-text">{text}</p>
    </section>
  )
}

export default DisclaimerSection
